import type { IApplicationState } from 'shared/types/redux';

export const rootStateBranchSelector =
  <ReduxStateBranchName extends keyof IApplicationState>(rootStateBranchName: ReduxStateBranchName) =>
  (state: IApplicationState): IApplicationState[ReduxStateBranchName] =>
    state[rootStateBranchName];
